import { db } from "./firebase"

// need to .then
const readFromDb = (collection: string, docKey: string): Promise<any> => {
  return db.collection(collection).doc(docKey).get()
}

export { readFromDb }
